/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceCategoryModel } from '../../models/service-category-model';

export interface ServiceCategoryPost$Params {
      body?: ServiceCategoryModel
}

export function serviceCategoryPost(http: HttpClient, rootUrl: string, params?: ServiceCategoryPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, serviceCategoryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<string>;
    })
  );
}

serviceCategoryPost.PATH = '/ServiceCategory';
